import { React, useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import axios from "axios";
import { ResearchAreaTable, ResearchAreaCreate } from "..";


function ResearchAreasSearch() {
  const [researchAreaName, setResearchAreaName] = useState("");

  const [researchAreas, setResearchAreas] = useState([]);
  const [updateTable, setUpdateTable] = useState(false);

  useEffect(() => {
    showResearchAreasSearchResults();
  }, [researchAreaName, updateTable]);

  const showResearchAreasSearchResults = () => {
    const body = new FormData();
    body.append("researchAreaName", researchAreaName);

    axios.post("/faculty/searchResearchAreas", body).then((res) => {
      const data = res.data;
      if (data.success) {
        setResearchAreas(data.researchAreas);
      } else {
      }
    });
  };

  const resetHooks = () => {
    setResearchAreaName("");
  };

  return (
    <div className="ResearchAreasSearch bg-brand-tertiary h-full">
      <div className="ResearchAreasSearch-container flex flex-col p-8 h-full">
        <div className="ResearchAreasSearch-topContainer flex flex-wrap">
          <div className="ResearchAreasSearch-searchBar flex search-button h-11 mr-4 w-60 mb-4">
            <input
              type="text"
              className="font-brand-quaternary h-full rounded-full ml-4 w-full"
              placeholder="Search"
              value={researchAreaName}
              onChange={(e) => setResearchAreaName(e.target.value)}
            />
            <div className="my-auto mx-2">
              <SearchIcon size={16} />
            </div>
          </div>

          <ResearchAreaCreate updateTable={updateTable} setUpdateTable={setUpdateTable} />

          <button type="button"
            className="search-button px-4 h-11 mb-4 text-center py-2" onClick={resetHooks}>
            Reset Search
          </button>
        </div>
        <div className="ResearchAreasSearch-bottomContainer flex w-full h-full">
          <ResearchAreaTable researchAreas={researchAreas} updateTable={updateTable} setUpdateTable={setUpdateTable} />
        </div>
      </div>
    </div>
  );
}

export default ResearchAreasSearch;
